import { useParams } from 'react-router-dom';
import { Button } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { useGetDocumentPdfMutation } from '@app/api/documentsApi';
import DocumentIcon from '@app/components/icons/DocumentIcon';
const CustomDocuments = ({ documents }) => {
    const { t } = useTranslation();
    const { id: loanId } = useParams();
    const [getDocumentPdf] = useGetDocumentPdfMutation();
    const handleGetDocumentPdf = (documentType) => {
        if (loanId) {
            getDocumentPdf({
                resourceId: loanId,
                documentType,
            });
        }
    };
    return documents.map((document) => (<Button key={document.name} variant="text" size="md" onClick={() => handleGetDocumentPdf(document.type)} iconLeft={<DocumentIcon className="size-4 shrink-0"/>} label={t(document.name)}/>));
};
export default CustomDocuments;
